import Markdown from 'markdown-to-jsx';
import * as React from 'react';
import { Link } from '../link';
import { List, ListItem } from '../list';
import { Text, TextAppearance, TextTag } from '../text';
var headline0400 = TextAppearance.headline0400,
    headline0350 = TextAppearance.headline0350,
    headline0250 = TextAppearance.headline0250,
    headline0200 = TextAppearance.headline0200,
    copy0200 = TextAppearance.copy0200;
var div = TextTag.div,
    h1 = TextTag.h1,
    h2 = TextTag.h2,
    h3 = TextTag.h3,
    h4 = TextTag.h4,
    strong = TextTag.strong,
    p = TextTag.p;
export function createTagOverride(component, props) {
  return {
    component: component,
    props: props
  };
}
var defaultMdOptions = {
  overrides: {
    h1: createTagOverride(Text, {
      tag: h1,
      appearance: headline0400
    }),
    h2: createTagOverride(Text, {
      tag: h2,
      appearance: headline0350
    }),
    h3: createTagOverride(Text, {
      tag: h3,
      appearance: headline0250
    }),
    h4: createTagOverride(Text, {
      tag: h4,
      appearance: headline0200
    }),
    p: createTagOverride(Text, {
      tag: p,
      appearance: copy0200
    }),
    span: createTagOverride(Text, {
      appearance: copy0200
    }),
    div: createTagOverride(Text, {
      tag: div,
      appearance: copy0200
    }),
    strong: createTagOverride(Text, {
      tag: strong,
      bold: true
    }),
    a: createTagOverride(Link, {
      isInline: true
    }),
    ul: createTagOverride(List),
    ol: createTagOverride(List, {
      isOrdered: true
    }),
    li: createTagOverride(ListItem)
  }
};
/**
 * These options should only be used if your component or project already uses the new Breakpoints.
 * These exported options are only intended for the time where we still support old and new breakpoints.
 * When the old breakpoints are deleted these options will be deprecated and eventually deleted.
 */

export var temporaryMdOverrides = {
  h1: createTagOverride(Text, {
    tag: h1,
    appearance: headline0400
  }),
  h2: createTagOverride(Text, {
    tag: h2,
    appearance: headline0350
  }),
  h3: createTagOverride(Text, {
    tag: h3,
    appearance: headline0250
  }),
  h4: createTagOverride(Text, {
    tag: h4,
    appearance: headline0200
  }),
  p: createTagOverride(Text, {
    tag: p,
    appearance: copy0200
  }),
  span: createTagOverride(Text, {
    appearance: copy0200
  }),
  div: createTagOverride(Text, {
    tag: div,
    appearance: copy0200
  }),
  strong: createTagOverride(Text, {
    tag: strong,
    bold: true
  }),
  a: createTagOverride(Link, {
    isInline: true
  }),
  ul: createTagOverride(List),
  ol: createTagOverride(List, {
    isOrdered: true
  }),
  li: createTagOverride(ListItem)
};
export var Richtext = function Richtext(props) {
  var markdown = props.markdown,
      overrides = props.overrides;
  var mdOptions = {
    overrides: Object.assign({}, defaultMdOptions.overrides, overrides)
  };
  return React.createElement(Markdown, {
    options: mdOptions
  }, markdown);
};